export default {"src":"/_next/static/media/m2.10d5025a.svg","height":172,"width":117,"blurWidth":0,"blurHeight":0};